<template>
  <div>
    <p class="mb-1">
      {{ question }}
    </p>
    <v-btn-toggle
      v-model="decision"
      @change="changeDecision"
      class="buttons"
    >
      <v-btn class="buttons__item">
        <v-icon v-if="decision === 0" color="white" left>
          mdi-check
        </v-icon>
        <span :class="decision === 0 ? 'white--text' : ''">
          {{ $t(`appointment.confirmAppointment.form.${yes}`) }}
        </span>
      </v-btn>
      <v-btn class="buttons__item">
        <v-icon v-if="decision === 1" color="white" left>
          mdi-check
        </v-icon>
        <span :class="decision === 1 ? 'white--text' : ''">
          {{ $t(`appointment.confirmAppointment.form.${no}`) }}
        </span>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import { yesNoDecisionIndex } from '../confirmAppointmentForm.helpers'

export default {
  name: 'FormAccepOrNot',

  props: {
    question: {
      type: String,
      required: true
    },

    yes: {
      type: String,
      default: 'yes'
    },
    no: {
      type: String,
      default: 'no'
    },

    initialValue: {
      type: Boolean,
      default: null
    },
  },

  methods: {
    changeDecision(value) {
      this.$emit('changeDecision', value)
    }
  },

  data() {
    return {
      decision: yesNoDecisionIndex(this.initialValue),
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons {
  width: 100%;

  &__item {
    width: 50% !important;

    &.v-item--active {
      color: #fff;
      background-color: #009DD9 !important;
    }
  }

  .v-btn {
    position: relative;

    &:nth-child(1) {
      margin-right: -1px;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }

    &:nth-child(2) {
      margin-left: -1px;
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
    }
  }
}
</style>
